module.exports = __webpack_public_path__ + "static/packagingnew-4afc64b55d1145775aa56853ea7dd456.mp4";